import SupersetDashboardEmbed from "src/components/Superset/SupersetDashboardEmbed.tsx";
import { useApplicationParameters } from "src/api/client-api/appParams";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const SupersetDashboard = (): JSX.Element => {
    const { applicationParameters } = useApplicationParameters();
    const { t } = useTranslation();

    return (
        <Box sx={{ padding: "40px 52px" }}>
            <Typography variant="h1" sx={{ marginRight: "8px" }}>
                {t("Dashboard")}
            </Typography>
            <SupersetDashboardEmbed dashboardUuid={applicationParameters?.supersetDashboardUuid ?? ""} />;
            {/*            <SupersetChartEmbed
                width="600px"
                height="500px"
                src={"http://localhost:8088/superset/explore/p/9k8VMqaVRzy/?standalone=1"}
            />*/}
        </Box>
    );
};
export default SupersetDashboard;
